import React, { memo, useEffect } from "react";
import { useState } from "react";
import { withRouter } from "react-router";
import ConfirmacionDialog from "../../../../../../components/Extra/ConfirmacionDialog";

// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  FormControl,
  IconButton,
  Popper,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { Cancel, Check, Create, Delete } from "@mui/icons-material";
import clienteAxios from "../../../../../../config/axios";
import { useContext } from "react";
import AlertaContext from "../../../../../../Context/Alerta/AlertaContext";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  celda: {
    fontSize: ".7rem !important",
    "&:hover": {
      opacity: ".7",
      cursor: "pointer",
    },
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "50px",
  },
}));

const RowArma = (props) => {
  const { row, index, item, setitem, deshabilitarbotones } = props;

  const [itemRow, setItemRow] = useState(row);
  const [medicinasData, setmedicinasData] = useState([]);
  const { mostrarAlerta } = useContext(AlertaContext);
  useEffect(() => {
    setItemRow(row);
    // eslint-disable-next-line
  }, [item]);
  const PopperMy = function(props) {
    return (
      <Popper {...props} style={useRowStyles.popper} placement="bottom-start" />
    );
  };
  const classes = useRowStyles();
  const handleChange = (e) => {
    setItemRow({ ...itemRow, [e.target.name]: e.target.value });
  };
  const handleEliminar = async (_id) => {
    setitem({
      ...item,
      hospMedicamentos: {
        medicamentosCabecera: item.hospMedicamentos.medicamentosCabecera.filter(
          (itemFilter, itemIndex) => {
            return row.order !== itemFilter.order;
          }
        ),
        medicamentosHorario: item.hospMedicamentos.medicamentosHorario.filter(
          (itemFilter, itemIndex) => {
            return row.order !== itemFilter.order;
          }
        ),
      },
    });
  };
  const funcionEdit = () => {
    seteditar(true);
  };
  const [editar, seteditar] = useState(false);
  const funcCancel = () => {
    setItemRow(row);
    seteditar(false);
  };
  const botonDisabled = () => {
    if (itemRow.medicina === "" || itemRow.valor === "") {
      return true;
    } else {
      return false;
    }
  };
  const funcSubmit = () => {
    setitem({
      ...item,
      hospMedicamentos: {
        medicamentosCabecera: item.hospMedicamentos.medicamentosCabecera.map(
          (itemFiltermedicamentosCabecera, itemIndex) => {
            if (itemRow.order === itemFiltermedicamentosCabecera.order) {
              return itemRow;
            } else {
              return itemFiltermedicamentosCabecera;
            }
          }
        ),
        medicamentosHorario: item.hospMedicamentos.medicamentosHorario.map(
          (itemFiltermedicamentosHorario, itemIndex) => {
            if (itemRow.order === itemFiltermedicamentosHorario.order) {
              return {
                ...itemFiltermedicamentosHorario,
                nameMedicinaHorarios: itemRow.medicina,
              };
            } else {
              return itemFiltermedicamentosHorario;
            }
          }
        ),
      },
    });
    seteditar(false);
  };
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  return (
    <React.Fragment>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        titulo="¿Esta seguro que quiere eliminar este Registro?"
        _id={itemRow._id}
        funcion={handleEliminar}
      />

      <TableRow className={classes.root} selected={index % 2 === 0}>
        {/* boton */}

        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {editar ? (
              <>
                <Tooltip title="Cancelar">
                  <IconButton
                    size="small"
                    onClick={() => {
                      funcCancel();
                    }}
                  >
                    <Cancel fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Confirmar">
                  <IconButton
                    size="small"
                    disabled={botonDisabled ? botonDisabled() : false}
                    onClick={() => {
                      funcSubmit();
                    }}
                  >
                    <Check
                      fontSize="small"
                      color={
                        botonDisabled
                          ? botonDisabled()
                            ? "inherit"
                            : "secondary"
                          : "secondary"
                      }
                    />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                {" "}
                <Tooltip title="Eliminar">
                  <IconButton
                    size="small"
                    disabled={deshabilitarbotones}
                    onClick={() => {
                      setopenConfirmDialog(true);
                    }}
                  >
                    <Delete
                      fontSize="small"
                      color={deshabilitarbotones ? "inherit" : "error"}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Editar">
                  <IconButton
                    size="small"
                    color={deshabilitarbotones ? "inherit" : "secondary"}
                    disabled={deshabilitarbotones}
                    onClick={() => {
                      funcionEdit();
                    }}
                  >
                    <Create />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
        </TableCell>

        {editar ? (
          <>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <FormControl fullWidth>
                <Autocomplete
                  filterOptions={(x) => x}
                  PopperComponent={PopperMy}
                  options={medicinasData.map((item) => {
                    return item.invNombre + "/+/" + item.invId;
                  })}
                  getOptionLabel={(option) => {
                    return option.split("/+/")[0];
                  }}
                  id="controlled-demo"
                  value={itemRow.medicina}
                  paperprops
                  onChange={async (event, newValue) => {
                    if (newValue) {
                      const options = newValue.split("/+/");
                      const itemF = medicinasData.find((itemPersona) => {
                        return itemPersona.invId === Number(options[1]);
                      });

                      setItemRow({
                        ...itemRow,
                        serie: itemF.invSerie,
                        medicina: itemF.invNombre,
                        llevaIva: itemF.invIva,
                        incluyeIva: itemF.invIncluyeIva,
                        precio: itemF.invprecios[0],
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      // error={error.recMascNombre}

                      fullWidth
                      onChange={async (e) => {
                        if (e.target.value === "") {
                          return;
                        }
                        try {
                          setItemRow({
                            ...itemRow,
                            medicina: e.target.value,
                          });
                          const res = await clienteAxios.get(
                            `/inventario/filtro/0?search=${e.target.value}&tipo=`
                          );

                          setmedicinasData(res.data.data);
                        } catch (error) {
                          mostrarAlerta("Hubo un error", "error");
                        }
                      }}
                      // InputProps={{
                      //   ...params.InputProps,
                      //   endAdornment: (
                      //     <React.Fragment>
                      //       {!editar ? (
                      //         <IconButton
                      //           size="small"
                      //           aria-label=""
                      //           onClick={async () => {
                      //             seteditarProveedor(false);
                      //             setopenProveedor(true);
                      //           }}
                      //         >
                      //           <AddCircleOutlineTwoTone color="primary" />
                      //         </IconButton>
                      //       ) : null}
                      //       {params.InputProps.endAdornment}
                      //     </React.Fragment>
                      //   ),
                      // }}
                    />
                  )}
                />
              </FormControl>
            </TableCell>
            <TableCell
              padding="normal"
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                name="dosis"
                value={itemRow.dosis}
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
              />
            </TableCell>
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                type={"number"}
                name="cantidad"
                value={itemRow.cantidad}
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
              />
            </TableCell>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                name="via"
                value={itemRow.via}
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
              />
            </TableCell>{" "}
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                type={"number"}
                name="inicio"
                value={itemRow.inicio}
                onChange={(e) => {
                  setItemRow({
                    ...itemRow,
                    inicio:
                      e.target.valueAsNumber > 23
                        ? 23
                        : e.target.valueAsNumber < 0
                        ? 0
                        : e.target.valueAsNumber,
                  });
                }}
                size="small"
                fullWidth
              />
            </TableCell>
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                type={"number"}
                name="frecuencia"
                value={itemRow.frecuencia}
                onChange={(e) => {
                  setItemRow({
                    ...itemRow,
                    frecuencia:
                      e.target.valueAsNumber < 1
                        ? 1
                        : e.target.valueAsNumber > 23
                        ? 23
                        : e.target.valueAsNumber,
                  });
                }}
                size="small"
                fullWidth
              />
            </TableCell>
          </>
        ) : (
          <>
            <TableCell size="small" align="center" className={classes.celda}>
              {itemRow.medicina}
            </TableCell>
            <TableCell size="small" align="center" className={classes.celda}>
              {itemRow.dosis}
            </TableCell>
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.cantidad}
            </TableCell>
            <TableCell size="small" align="center" className={classes.celda}>
              {itemRow.via}
            </TableCell>{" "}
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.inicio}
            </TableCell>
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.frecuencia}
            </TableCell>
          </>
        )}
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(RowArma));
